export const LastLoginInfoState = {
  lastLoginInfo: {
    city: undefined,
    country: undefined,
    hostname: undefined,
    ipAddress: undefined,
    isDialogVisible: false,
    loginDate: undefined,
    region: undefined,
  },
}

export const LastLoginInfoActions = {
  hideLastLoginInfoDialog: ({ commit }) => {
    commit('setLastLoginInfoDialogVisibility', false)
  },

  showLastLoginInfoDialog: ({ commit }) => {
    commit('setLastLoginInfoDialogVisibility', true)
  },

  updateLastLoginInfo: ({ commit }, info) => {
    commit('setLastLoginInfo', info)
    if (info.ip_changed) commit('setLastLoginInfoDialogVisibility', true)
  },
}

export const LastLoginInfoMutations = {
  setLastLoginInfo: (state, payload) => {
    state.lastLoginInfo.loginDate = payload.date || ''
    state.lastLoginInfo.ipAddress = payload.ip || ''
    state.lastLoginInfo.hostname = payload.host || ''
    state.lastLoginInfo.country = payload.country || ''
    state.lastLoginInfo.region = payload.region || ''
    state.lastLoginInfo.city = payload.city || ''
  },

  setLastLoginInfoDialogVisibility: (state, payload) => {
    state.lastLoginInfo.isDialogVisible = payload
  },
}

export const LastLoginInfoGetters = {
  getLastLoginInfoDialogState: state => {
    return state.lastLoginInfo.isDialogVisible
  },

  getLastLoginIPAndHost: state => {
    if (!state.lastLoginInfo.ipAddress) return 'Unknown'
    if (!state.lastLoginInfo.hostname) return state.lastLoginInfo.ipAddress
    return `${state.lastLoginInfo.ipAddress} (${state.lastLoginInfo.hostname})`
  },

  getLastLoginDate: state => {
    return state.lastLoginInfo.loginDate || 'Unknown'
  },

  getLastLoginLocation: state => {
    return [
      state.lastLoginInfo.city,
      state.lastLoginInfo.region,
      state.lastLoginInfo.country,
    ].filter(d => !!d).join(' / ') || 'Unknown'
  },
}
